export enum MusicMode {
  BrandKit = "BrandKit",
  Auto = "Auto",
  Upload = "Upload",
  Off = "Off",
}

export const deriveMusicMode = ({
  isFlashProject,
  autoSelectMusic,
  includeMusic,
  musicAssetId,
  brandKitAssetId,
}: {
  isFlashProject: boolean;
  autoSelectMusic: boolean | null | undefined;
  includeMusic: boolean | null | undefined;
  musicAssetId: string | null | undefined;
  brandKitAssetId: string | null | undefined;
}): MusicMode => {
  if (isFlashProject && autoSelectMusic) return MusicMode.Auto;

  if (includeMusic === false) return MusicMode.Off;

  // No settings saved yet and nothing to fall back on: default to Off.
  if (!brandKitAssetId && !musicAssetId) return MusicMode.Off;

  // A picked asset that matches the brand kit track (or no explicit pick,
  // relying on the brand kit default) is shown as the Brand Kit mode.
  if (musicAssetId == null || musicAssetId === brandKitAssetId) {
    return MusicMode.BrandKit;
  }

  return MusicMode.Upload;
};
